import { ImagePicture } from 'approot/shared/images/images';

import womanWithExclamationMarkAvif from './content-woman-with-exclamation-mark.avif';
import womanWithExclamationMarkWebp from './content-woman-with-exclamation-mark.webp';
import womanWithExclamationMarkPng from './content-woman-with-exclamation-mark.png';

const ImageContentWomanWithExclamationMark = ({
  width,
  lazyLoad = true,
}: {
  width?: number;
  lazyLoad?: boolean;
}) => (
  <ImagePicture
    lazyLoad={lazyLoad}
    avif={{ path: womanWithExclamationMarkAvif }}
    webp={{ path: womanWithExclamationMarkWebp }}
    png={{ path: womanWithExclamationMarkPng }}
    style={width ? { width } : undefined}
  />
);

export default ImageContentWomanWithExclamationMark;
